import { Grid, Pagination, PaginationItem, Typography } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useThemePalette } from "common/hooks/theme_palette";

const Footer = ({
  total_count,
  totalPage,
  size = "small",
  shape = "rounded",
  paginationPage,
  handlePageChange,
}) => {
  const { primary } = useThemePalette();

  // Calculate the number of items shown on the current page
  // Assuming a page size of 10 based on the calculation Math.ceil(total_count / 10)
  const pageSize = 10;
  const currentShown = Math.min(
    pageSize,
    total_count - (paginationPage - 1) * pageSize
  );

  return (
    totalPage > 1 && (
      <Grid
        container
        item
        alignItems="center"
        justifyContent="space-between"
        xs={12}
        mb={7.5}
        // mt={5}
        // bgcolor="white"
        // px={2}
      >
        <Pagination
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: KeyboardDoubleArrowLeftIcon,
                last: KeyboardDoubleArrowRightIcon,
                previous: KeyboardArrowLeftIcon,
                next: KeyboardArrowRightIcon,
              }}
              {...item}
              sx={{
                width: 40,
                height: 40,
                "&.Mui-selected": {
                  bgcolor: primary,
                  color: "white",
                  "&:hover": {
                    bgcolor: primary,
                  },
                },
              }}
            />
          )}
          count={Math.ceil(total_count / 10)}
          sx={{
            fontFamily: "Cairo",
            gap: 2,
            bgcolor: "white",
            borderRadius: 2,
          }}
          size={size}
          shape={shape}
          page={paginationPage}
          showFirstButton
          showLastButton
          onChange={(e, data) => handlePageChange(data)}
        />
        <Typography
          sx={{
            fontFamily: "Cairo",
            fontWeight: 500,
            fontSize: "14px",
            color: "#666", // Or use a color from theme if available, e.g. textGray
          }}
        >
          Showing {currentShown} results from {total_count} results
        </Typography>
      </Grid>
    )
  );
};

export default Footer;
